export default __webpack_public_path__ + "static/media/bgsir.17dcce27.jpg";